import {authActionTypes} from './authActionTypes.js';

const token = localStorage.getItem('token')
  ? localStorage.getItem('token')
  : null;

const INITIAL_STATE = {
  currentUser: null,
  token: token,
  error: null,
  loading: false,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case authActionTypes.AUTH_START:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case authActionTypes.AUTH_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        token: action.payload.token,
        currentUser: action.payload.agent,
      };
    case authActionTypes.AUTH_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case authActionTypes.AUTH_LOGOUT:
      return {
        ...state,
        currentUser: null,
        token: null,
      };
    default:
      return state;
  }
};

export default authReducer;
